import { categories, categoryTabHint } from "@/mocks/home";

export default function CategoryIndex() {
  return (
    <section id="categories" className="w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-[1180px] px-4 md:px-6">
        <div className="flex flex-col gap-3 border-b border-background-300 pb-6 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.2em] text-primary-700">
              01 / RESOURCE SECTIONS
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-[32px]">
              四大分区，先锁定范围
            </h2>
          </div>
          <p className="max-w-md text-sm leading-6 text-foreground-600">
            {categoryTabHint}。每个分区都有独立的收录量与子标签，浏览时先看分区再看索引，路径更短。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {categories.map((item) => (
            <article
              key={item.key}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-300 bg-background-50 transition hover:border-primary-300"
            >
              <div className="relative h-40 w-full overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.name}分区索引`}
                  title={`${item.name} · 91下载资源大全`}
                  className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-[11px] font-medium text-foreground-800">
                  {item.count}
                </span>
              </div>

              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-lg font-bold text-foreground-950">
                  {item.name}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-6 text-foreground-600">{item.desc}</p>
                <div className="mt-4 flex flex-wrap gap-1.5">
                  {item.tags.map((tag) => (
                    <span
                      key={tag}
                      className="rounded-full bg-secondary-100 px-2.5 py-1 text-[11px] text-secondary-900"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
                <a
                  href="#hot"
                  className="mt-5 inline-flex cursor-pointer items-center gap-1 text-sm font-medium text-primary-700 transition group-hover:gap-2"
                >
                  浏览该分区
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}